import ApiClient from '../../client';

// Hand-written single-object module keyed by matchId. Unlike the dataprovider helper,
// it does not dedupe across instances; the route param drives reload via load(matchId).
export const state = () => ({
  match: null,
  matchId: null,
  loading: false,
  failed: false
});

export const getters = {
  getMatch: (state) => state.match,
  isLoading: (state) => state.loading,
  failed: (state) => state.failed
};

export const mutations = {
  setMatch(state, payload) {
    state.match = payload?.match || null;
    state.matchId = payload?.matchId || null;
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
  setFailed(state, failed) {
    state.failed = failed;
  },
  clear(state) {
    state.match = null;
    state.matchId = null;
    state.loading = false;
    state.failed = false;
  }
};

export const actions = {
  async load({ commit, state }, matchId) {
    if (state.matchId === matchId && state.match && !state.failed) {
      return state.match;
    }
    commit('setLoading', true);
    commit('setFailed', false);
    try {
      const response = await ApiClient.getMatch(matchId);
      commit('setMatch', { match: response.data, matchId });
      commit('setLoading', false);
      return response.data;
    } catch (err) {
      commit('setMatch', { match: null, matchId: null });
      commit('setFailed', true);
      commit('setLoading', false);
      throw err;
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
